module.exports = __webpack_public_path__ + "static/media/cake-unplayed.8da14c6c.png";